import type { OnboardingStep } from "@/components/onboarding/OnboardingProvider";

// Main event categories
export enum SegmentEvents {
  ONBOARDING = "Onboarding",
  SUBSCRIBE = "Subscribe",
  AUTHENTICATION = "Authentication",
}

// Authentication action types
export enum AuthenticationStep {
  DISCOVERY_PAGE = "discovery_page",
  CREATE_ORGANIZATION = "create_organization",
  SELECT_ORGANIZATION = "select_organization",
}

// Subscription action types
export enum SubscriptionStep {
  LOGGED_IN_NOT_SUBSCRIBED = "logged_in_not_subscribed",
}

// Base properties for all events
export interface BaseEventPayload {
  // Common properties that might be used across different events
  timestamp?: number;
  userId?: string;
}

// Onboarding specific payload
export interface OnboardingEventPayload extends BaseEventPayload {
  step: OnboardingStep;
  isSkipped?: boolean;
  additionalParams?: Record<string, unknown>;
}

// Authentication specific payload
export interface AuthEventPayload extends BaseEventPayload {
  step: AuthenticationStep;
  additionalParams?: Record<string, unknown>;
}

// Subscription specific payload
export interface SubscriptionEventPayload extends BaseEventPayload {
  step: SubscriptionStep;
  additionalParams?: Record<string, unknown>;
}

// Union type for all possible event payloads
export type EventPayload =
  | OnboardingEventPayload
  | AuthEventPayload
  | SubscriptionEventPayload;

/**
 * Map events to their specific payload types:
 * This can be extended to include one off events and additional
 * flows or screens. Like Dashboard, Clients, Settings etc.
 */
export interface EventPayloads {
  // Main Flows
  [SegmentEvents.ONBOARDING]: OnboardingEventPayload;
  [SegmentEvents.AUTHENTICATION]: AuthEventPayload;
  [SegmentEvents.SUBSCRIBE]: SubscriptionEventPayload;

  // One off events
}
